export const HEAT_SLOTS = [6, 8, 10, 12, 14, 16, 18, 20];
export const HEAT_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function hourLabel(hour) {
  const h = ((hour % 24) + 24) % 24;
  return `${h % 12 || 12} ${h < 12 ? 'AM' : 'PM'}`;
}

export function slotLabel(start) {
  const end = (start + 2) % 24;
  const [startHour, startPeriod] = hourLabel(start).split(' ');
  const [endHour, endPeriod] = hourLabel(end).split(' ');
  return startPeriod === endPeriod ? `${startHour}–${endHour} ${endPeriod}` : `${startHour} ${startPeriod}–${endHour} ${endPeriod}`;
}

export const MIN_POSTS_FOR_TIMING = 8;

// Best posting window from real results: each post's views are added to the slot it was published in.
// A recommendation is only made when enough posts with views exist; otherwise nothing is guessed.
export function buildPostingHeatmap(posts, now = new Date()) {
  const grid = HEAT_DAYS.map(() => HEAT_SLOTS.map(() => 0));
  const dayFormat = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'Asia/Kolkata' });
  const hourFormat = new Intl.DateTimeFormat('en-IN', { hour: '2-digit', hourCycle: 'h23', timeZone: 'Asia/Kolkata' });
  let sampleSize = 0;
  posts.forEach((post) => {
    const views = Number(post.views ?? post.viewCount ?? post.metrics?.views ?? post.summary?.views ?? 0);
    const date = new Date(post.publishedAt || post.createdAt || 0);
    if (!(views > 0) || Number.isNaN(date.getTime())) return;
    const day = HEAT_DAYS.indexOf(dayFormat.format(date));
    const slot = Math.floor((Number(hourFormat.format(date)) - HEAT_SLOTS[0]) / 2);
    if (day < 0 || slot < 0 || slot >= HEAT_SLOTS.length) return;
    grid[day][slot] += views;
    sampleSize += 1;
  });
  const hasHistory = sampleSize >= MIN_POSTS_FOR_TIMING;
  const today = Math.max(0, HEAT_DAYS.indexOf(dayFormat.format(now)));
  const row = grid[today].some(Boolean) ? grid[today] : HEAT_SLOTS.map((_, slot) => grid.reduce((total, days) => total + days[slot], 0));
  const bestSlot = hasHistory ? row.indexOf(Math.max(...row)) : -1;
  const peak = Math.max(...grid.flat(), 1);
  return { grid, hasHistory, sampleSize, today, bestSlot, label: hasHistory ? slotLabel(HEAT_SLOTS[bestSlot]) : '', peak };
}
